<template>
  <Modal :id="'cmp-catalog-products-catalog_alert_modal'" @cancelled="onCancel">
    <template slot="header"></template>
    <template slot="body">
      <NTable
        :id="'cmp-catalog-products-barcode_alert_modal'"
        :items="list"
        :config="tableConfig"
        :headers="headers"
        class="catalog_alert_modal"
        :showNoItems="false"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
     
  
       
            <td v-bind="tdcon('catalog_no')">
              <TextField2
                :id="'catalog_no'"
                :showLabel="false"
                :value="item['catalog_no']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
            </td>
            <td v-bind="tdcon('label')">
              <span class="txtov" :title="item['label_name']">
                {{ item["label_name"] }}
              </span>
            </td>
          </tr>
        </template>
      </NTable>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("close") }}
      </button>
    </template>
  </Modal>
</template>
  
  <script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { ProductsService } from "../../services/products.service";
import { Subject } from "rxjs";
import NTable from "@/plugins/datatable/datatable";
import InputField from "../../../../plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
export default {
  components: {
    Modal,
    SearchList,
    InputField,
    NTable,
  },
  props: ["selectedTrack"],
  data() {
    return {
      products: [],
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      tableConfig: createNTableConfig({
        headerStyle: 4,
        rowHeight: 30,
        fullHeight: true,
        footer: false,
      }),
    };
  },
  mounted: async function () {
    const res = await ProductsService.getBarcodeCatalogError(this.product_id,'catalog');
    this.products = res.data.products;
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("catalog_no"),
        createTableHeader("label", ),
      

      ];
    },
    list: function () {
      return this.products;
    },
    product_id: function () {
      return this.$route.query.product_id;
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function (event, item) {
        console.log('event',event)
        console.log('item',item)
      const { name, value } = event;
      this.$emit("changed", { name, value, kVal: item.product_id });
    },
  },
};
</script>
<style lang="scss">
.cmp-catalog-products-catalog_alert_modal {
  .catalog_alert_modal {
    --ntable-height: 400px !important;
    --tb-layout: fixed;
    tr {
      padding-left: 5px;
    }
  }
  .dt-modal--body {
    tbody {
      margin-left: 0px;
      background: #f8f8f8;
      display: flex;
      flex-direction: column;
      border: 1px solid var(--sprt-5);
      border-radius: 3px;
      padding-bottom: 10px;
      max-height: var(--body-height);
      min-height: var(--body-height);
    }
  }
  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }
  .checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .select-checkbox {
      padding-right: 5px;
    }
  }
}
</style>

  